export interface ComicChapter {
  no: number;
  title: string;
  updatedAt: string;
  views: number;
}

export interface ComicWork {
  id: string;
  title: string;
  cover: string;
  category: string;
  author: string;
  authorId: string;
  status: "连载中" | "已完结" | "不定期更新";
  rating: number;
  subscribers: number;
  description: string;
  tags: string[];
  lastChapter: string;
  lastUpdated: string;
  chapters: ComicChapter[];
  hot?: boolean;
  newUpdate?: boolean;
}

export interface ComicAuthor {
  id: string;
  name: string;
  avatar: string;
  intro: string;
  works: string[];
  followers: number;
  signature: string;
}

export const categories = [
  { key: "all", label: "全部作品" },
  { key: "热血冒险", label: "热血冒险" },
  { key: "奇幻魔法", label: "奇幻魔法" },
  { key: "科幻未来", label: "科幻未来" },
  { key: "都市青春", label: "都市青春" },
  { key: "悬疑推理", label: "悬疑推理" },
  { key: "温馨治愈", label: "温馨治愈" },
  { key: "恋爱", label: "恋爱" },
  { key: "搞笑日常", label: "搞笑日常" },
];

export const works: ComicWork[] = [
  {
    id: "linglong-gu",
    title: "灵笼之谷",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20fantasy%20comic%20cover%20art%20of%20a%20young%20adventurer%20holding%20a%20glowing%20jade%20orb%20in%20a%20misty%20forest%20valley%2C%20lush%20green%20foliage%2C%20ethereal%20light%2C%20dynamic%20composition%2C%20anime%20illustration%20style%2C%20rich%20colors%2C%20high%20detail&width=600&height=800&seq=m-linglong-01&orientation=portrait",
    category: "奇幻魔法",
    author: "林知远",
    authorId: "linzhiyuan",
    status: "连载中",
    rating: 9.4,
    subscribers: 128600,
    description:
      "在灵笼之谷的古老封印松动之际，少女苏禾意外唤醒了沉睡百年的守谷之灵。她必须赶在暗潮吞噬山谷之前，集齐五枚灵玉，揭开身世之谜。宏大世界观与细腻情感交织，每一话都在铺展一场关于守护与成长的冒险。",
    tags: ["奇幻", "冒险", "成长", "东方玄幻"],
    lastChapter: "第 96 话 雾海潮生",
    lastUpdated: "2026-08-16",
    hot: true,
    newUpdate: true,
    chapters: Array.from({ length: 96 }, (_, i) => ({
      no: 96 - i,
      title: i === 0 ? "雾海潮生" : `灵玉 · 第 ${96 - i} 话`,
      updatedAt: i === 0 ? "2026-08-16" : "2026-08-12",
      views: 32000 - i * 120,
    })),
  },
  {
    id: "xingchen-lieshou",
    title: "星辰猎手",
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20anime%20comic%20cover%20of%20a%20space%20bounty%20hunter%20in%20sleek%20dark%20armor%20holding%20an%20energy%20rifle%2C%20neon%20starfield%20nebula%20background%2C%20teal%20and%20amber%20accents%2C%20cinematic%20dynamic%20pose%2C%20futuristic%20illustration&width=600&height=800&seq=m-xingchen-01&orientation=portrait",
    category: "科幻未来",
    author: "程野",
    authorId: "cheng-ye",
    status: "连载中",
    rating: 9.1,
    subscribers: 98200,
    description:
      "星际边陲，猎手夜枭以缉捕通缉犯为生。一次看似普通的委托，却让他卷入银河议会与叛军之间的惊天阴谋。硬核科幻设定、环环相扣的剧情反转，加上酣畅淋漓的宇宙追逐战。",
    tags: ["科幻", "太空", "动作", "悬疑"],
    lastChapter: "第 74 话 星门之后",
    lastUpdated: "2026-08-15",
    hot: true,
    newUpdate: true,
    chapters: Array.from({ length: 74 }, (_, i) => ({
      no: 74 - i,
      title: i === 0 ? "星门之后" : `航行日志 · 第 ${74 - i} 话`,
      updatedAt: i === 0 ? "2026-08-15" : "2026-08-10",
      views: 27000 - i * 130,
    })),
  },
  {
    id: "siji-xiaoxi",
    title: "四季小憩",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20healing%20comic%20cover%20of%20a%20small%20cozy%20teahouse%20in%20a%20blooming%20garden%2C%20warm%20pastel%20palette%2C%20a%20gentle%20character%20pouring%20tea%20with%20soft%20sunlight%2C%20wholesome%20slice%20of%20life%20illustration&width=600&height=800&seq=m-siji-01&orientation=portrait",
    category: "温馨治愈",
    author: "青禾",
    authorId: "qing-he",
    status: "连载中",
    rating: 9.6,
    subscribers: 156700,
    description:
      "城市里的年轻人回到故乡小镇，接手了一间奶奶留下的茶屋。四季流转，人来人往，一壶热茶里装着许多温柔的故事。画风清新治愈，是都市生活里的一剂良药。",
    tags: ["治愈", "日常", "温情", "美食"],
    lastChapter: "第 41 话 春茶初醒",
    lastUpdated: "2026-08-14",
    hot: true,
    chapters: Array.from({ length: 41 }, (_, i) => ({
      no: 41 - i,
      title: i === 0 ? "春茶初醒" : `四季 · 第 ${41 - i} 话`,
      updatedAt: i === 0 ? "2026-08-14" : "2026-08-08",
      views: 19000 - i * 100,
    })),
  },
  {
    id: "yifeng-lai-xin",
    title: "一封来信",
    cover: "https://readdy.ai/api/search-image?query=Romance%20anime%20comic%20cover%20of%20two%20young%20people%20exchanging%20letters%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20tones%2C%20gentle%20youthful%20atmosphere%2C%20delicate%20illustration&width=600&height=800&seq=m-yifeng-01&orientation=portrait",
    category: "恋爱",
    author: "苏言",
    authorId: "su-yan",
    status: "已完结",
    rating: 9.3,
    subscribers: 112300,
    description:
      "高中时代的最后一封情书，时隔十年被重新寄回。两人在各自的城市各自成长，一封封往来信件串联起错过与重逢。细腻的心理描写与克制的情感，打动无数读者的青春恋曲。",
    tags: ["恋爱", "青春", "书信", "治愈"],
    lastChapter: "番外 · 仲夏夜之信",
    lastUpdated: "2026-07-30",
    chapters: Array.from({ length: 88 }, (_, i) => ({
      no: 88 - i,
      title: i === 0 ? "番外 · 仲夏夜之信" : `信件 · 第 ${88 - i} 话`,
      updatedAt: i === 0 ? "2026-07-30" : "2026-07-20",
      views: 24000 - i * 110,
    })),
  },
  {
    id: "anhang-dujiao",
    title: "暗航独驾",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20detective%20comic%20cover%20of%20a%20lone%20detective%20in%20a%20dim%20rainy%20city%20alley%20holding%20a%20glowing%20clue%2C%20moody%20teal%20and%20amber%20lighting%2C%20noir%20atmosphere%2C%20cinematic%20illustration&width=600&height=800&seq=m-anhang-01&orientation=portrait",
    category: "悬疑推理",
    author: "程野",
    authorId: "cheng-ye",
    status: "连载中",
    rating: 9.0,
    subscribers: 87600,
    description:
      "深夜里，只有出租车司机能看见城市隐藏的黑暗面。每一次载客都是一场解谜，乘客的身份、目的地与谎言交织成一张巨网。单元式案件与贯穿主线的诡异组织并存。",
    tags: ["悬疑", "推理", "都市", "犯罪"],
    lastChapter: "第 52 话 雾夜乘客",
    lastUpdated: "2026-08-13",
    newUpdate: true,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      no: 52 - i,
      title: i === 0 ? "雾夜乘客" : `夜间司机 · 第 ${52 - i} 话`,
      updatedAt: i === 0 ? "2026-08-13" : "2026-08-06",
      views: 21000 - i * 100,
    })),
  },
  {
    id: "shiguang-fangying",
    title: "时光放映厅",
    cover: "https://readdy.ai/api/search-image?query=Magical%20cinema%20comic%20cover%20of%20an%20old%20movie%20theater%20with%20glowing%20projector%20light%20and%20floating%20film%20reels%2C%20whimsical%20warm%20tones%2C%20nostalgic%20fantasy%20illustration&width=600&height=800&seq=m-shiguang-01&orientation=portrait",
    category: "奇幻魔法",
    author: "林知远",
    authorId: "linzhiyuan",
    status: "不定期更新",
    rating: 8.8,
    subscribers: 65400,
    description:
      "小镇尽头有一家只在雨夜营业的电影院，放映的每部电影都与一位观众的记忆相连。当放映厅的灯光亮起，时间便开始倒流。唯美的分镜与关于遗忘与怀念的故事。",
    tags: ["奇幻", "怀旧", "情感", "单元剧"],
    lastChapter: "第 28 话 散场以后",
    lastUpdated: "2026-08-11",
    chapters: Array.from({ length: 28 }, (_, i) => ({
      no: 28 - i,
      title: i === 0 ? "散场以后" : `午夜场 · 第 ${28 - i} 话`,
      updatedAt: i === 0 ? "2026-08-11" : "2026-07-25",
      views: 15000 - i * 90,
    })),
  },
  {
    id: "huoyan-fengyun",
    title: "火焰风云",
    cover: "https://readdy.ai/api/search-image?query=Action%20shonen%20comic%20cover%20of%20a%20fierce%20martial%20artist%20unleashing%20fire%20energy%2C%20dramatic%20warm%20red%20and%20orange%20palette%2C%20dynamic%20speed%20lines%2C%20explosive%20energetic%20anime%20style&width=600&height=800&seq=m-huoyan-01&orientation=portrait",
    category: "热血冒险",
    author: "陈山明",
    authorId: "chenshanming",
    status: "连载中",
    rating: 9.2,
    subscribers: 143900,
    description:
      "少年陆炎背负家族的宿命，在武道大会的擂台上逐渐觉醒传说中的火炎之力。热血对决、师门恩怨与友情羁绊，一部让肾上腺素飙升的燃系长篇。",
    tags: ["热血", "武斗", "成长", "燃"],
    lastChapter: "第 120 话 火种不灭",
    lastUpdated: "2026-08-17",
    hot: true,
    newUpdate: true,
    chapters: Array.from({ length: 120 }, (_, i) => ({
      no: 120 - i,
      title: i === 0 ? "火种不灭" : `焚天 · 第 ${120 - i} 话`,
      updatedAt: i === 0 ? "2026-08-17" : "2026-08-14",
      views: 41000 - i * 150,
    })),
  },
  {
    id: "dushi-miyin",
    title: "都市蜜饮",
    cover: "https://readdy.ai/api/search-image?query=Urban%20slice%20of%20life%20comic%20cover%20of%20a%20stylish%20young%20barista%20at%20a%20trendy%20cafe%20window%2C%20modern%20city%20street%2C%20fresh%20mint%20and%20coral%20tones%2C%20upbeat%20youthful%20illustration&width=600&height=800&seq=m-dushi-01&orientation=portrait",
    category: "都市青春",
    author: "苏言",
    authorId: "su-yan",
    status: "连载中",
    rating: 8.9,
    subscribers: 78900,
    description:
      "名牌大学毕业的苏漫辞去高薪工作，在街角开了一家小小的饮品店。形形色色的客人带来形形色色的烦恼，她用一杯杯特调饮品治愈他们，也慢慢找回自己的方向。",
    tags: ["都市", "成长", "职场", "轻甜"],
    lastChapter: "第 39 话 柠檬气泡",
    lastUpdated: "2026-08-12",
    chapters: Array.from({ length: 39 }, (_, i) => ({
      no: 39 - i,
      title: i === 0 ? "柠檬气泡" : `今日特调 · 第 ${39 - i} 话`,
      updatedAt: i === 0 ? "2026-08-12" : "2026-08-04",
      views: 17000 - i * 90,
    })),
  },
  {
    id: "momo-tuanzi",
    title: "糯糯团子",
    cover: "https://readdy.ai/api/search-image?query=Cute%20comedic%20comic%20cover%20of%20round%20fluffy%20animal%20companions%20making%20mochi%20in%20a%20colorful%20kitchen%2C%20adorable%20chibi%20characters%2C%20pastel%20green%20and%20yellow%20palette%2C%20playful%20illustration&width=600&height=800&seq=m-momo-01&orientation=portrait",
    category: "搞笑日常",
    author: "青禾",
    authorId: "qing-he",
    status: "连载中",
    rating: 9.5,
    subscribers: 132800,
    description:
      "三只来自月球的团子精落地地球，寄宿在一对姐弟家中。它们最爱软糯的糯米点心，也总能把平凡日常闹得天翻地覆。萌度爆表、笑点密集的轻松日常。",
    tags: ["搞笑", "萌宠", "日常", "治愈"],
    lastChapter: "第 66 话 团子大作战",
    lastUpdated: "2026-08-16",
    hot: true,
    newUpdate: true,
    chapters: Array.from({ length: 66 }, (_, i) => ({
      no: 66 - i,
      title: i === 0 ? "团子大作战" : `团子日常 · 第 ${66 - i} 话`,
      updatedAt: i === 0 ? "2026-08-16" : "2026-08-09",
      views: 30000 - i * 120,
    })),
  },
  {
    id: "xuanji-shanhai",
    title: "玄机山海",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20comic%20cover%20of%20a%20hero%20standing%20before%20towering%20mythical%20mountains%20with%20floating%20ancient%20runes%20and%20a%20giant%20spirit%20beast%20silhouette%2C%20deep%20emerald%20and%20gold%20palette%2C%20epic%20oriental%20fantasy&width=600&height=800&seq=m-xuanji-01&orientation=portrait",
    category: "奇幻魔法",
    author: "陈山明",
    authorId: "chenshanming",
    status: "连载中",
    rating: 9.0,
    subscribers: 96800,
    description:
      "山海经中的神兽与现实世界交错，少年方远被选中成为「驭兽者」。每收服一只神兽便多一份力量，也离那场即将到来的灭世灾劫更近一步。东方神话与现代都市的碰撞。",
    tags: ["神话", "东方玄幻", "驭兽", "冒险"],
    lastChapter: "第 83 话 应龙苏醒",
    lastUpdated: "2026-08-14",
    newUpdate: true,
    chapters: Array.from({ length: 83 }, (_, i) => ({
      no: 83 - i,
      title: i === 0 ? "应龙苏醒" : `山海志 · 第 ${83 - i} 话`,
      updatedAt: i === 0 ? "2026-08-14" : "2026-08-07",
      views: 26000 - i * 110,
    })),
  },
  {
    id: "banxing-mendian",
    title: "半夏门点",
    cover: "https://readdy.ai/api/search-image?query=Youth%20sports%20comic%20cover%20of%20energetic%20high%20school%20students%20at%20a%20small%20night%20market%20stall%20with%20warm%20lanterns%2C%20vibrant%20teal%20and%20coral%20tones%2C%20lively%20youthful%20group%20illustration&width=600&height=800&seq=m-banxing-01&orientation=portrait",
    category: "都市青春",
    author: "程野",
    authorId: "cheng-ye",
    status: "已完结",
    rating: 8.7,
    subscribers: 54300,
    description:
      "大学四年的最后一年，六个性格迥异的年轻人合伙在校门口摆起夜宵摊。从手忙脚乱到门庭若市，青春、友情与梦想在烟火气里发光。毕业前的最后一个夏天。",
    tags: ["青春", "创业", "友情", "美食"],
    lastChapter: "完结篇 · 毕业夜",
    lastUpdated: "2026-06-28",
    chapters: Array.from({ length: 70 }, (_, i) => ({
      no: 70 - i,
      title: i === 0 ? "完结篇 · 毕业夜" : `夜宵摊 · 第 ${70 - i} 话`,
      updatedAt: i === 0 ? "2026-06-28" : "2026-06-15",
      views: 16000 - i * 80,
    })),
  },
  {
    id: "shiyue-xingji",
    title: "拾月星际",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20sci-fi%20comic%20cover%20of%20a%20cheerful%20crew%20piloting%20a%20small%20starship%20through%20colorful%20planets%20and%20star%20clusters%2C%20bright%20saturated%20palette%2C%20fun%20lighthearted%20space%20adventure%20illustration&width=600&height=800&seq=m-shiyue-01&orientation=portrait",
    category: "科幻未来",
    author: "林知远",
    authorId: "linzhiyuan",
    status: "连载中",
    rating: 8.8,
    subscribers: 68700,
    description:
      "一条送货飞船、一船可爱的成员，穿梭在银河的各个角落接单送货。轻快的宇宙日常中偶尔藏着关于文明与家园的深刻思考。旅途即是最好的答案。",
    tags: ["科幻", "太空", "轻喜剧", "冒险"],
    lastChapter: "第 47 话 彗星邮差",
    lastUpdated: "2026-08-10",
    chapters: Array.from({ length: 47 }, (_, i) => ({
      no: 47 - i,
      title: i === 0 ? "彗星邮差" : `银河快运 · 第 ${47 - i} 话`,
      updatedAt: i === 0 ? "2026-08-10" : "2026-07-28",
      views: 14000 - i * 80,
    })),
  },
  {
    id: "shengming-yiyuan",
    title: "生命医院",
    cover: "https://readdy.ai/api/search-image?query=Emotional%20medical%20drama%20comic%20cover%20of%20a%20compassionate%20doctor%20silhouette%20in%20a%20softly%20lit%20hospital%20hallway%20at%20dawn%2C%20hopeful%20warm%20teal%20and%20cream%20palette%2C%20tender%20dramatic%20illustration&width=600&height=800&seq=m-shengming-01&orientation=portrait",
    category: "温馨治愈",
    author: "青禾",
    authorId: "qing-he",
    status: "不定期更新",
    rating: 9.1,
    subscribers: 71500,
    description:
      "深夜的急诊科，每扇门后都有一个关于生命的故事。以医生视角记录生死之间的悲欢与温情，克制而真诚地讲述医患之间的信任与理解。",
    tags: ["医疗", "治愈", "纪实", "人性"],
    lastChapter: "第 33 话 凌晨三点",
    lastUpdated: "2026-08-08",
    chapters: Array.from({ length: 33 }, (_, i) => ({
      no: 33 - i,
      title: i === 0 ? "凌晨三点" : `查房手记 · 第 ${33 - i} 话`,
      updatedAt: i === 0 ? "2026-08-08" : "2026-07-18",
      views: 18000 - i * 90,
    })),
  },
];

export const authors: ComicAuthor[] = [
  {
    id: "linzhiyuan",
    name: "林知远",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20kind%20male%20comic%20artist%20with%20a%20paintbrush%20and%20warm%20smile%2C%20soft%20green%20studio%20background%2C%20friendly%20anime%20character%20portrait&width=400&height=400&seq=a-linzhiyuan-01&orientation=squarish",
    intro: "擅长宏大世界观与细腻情感描写的奇幻题材作者，代表作《灵笼之谷》《时光放映厅》《拾月星际》。",
    works: ["灵笼之谷", "时光放映厅", "拾月星际"],
    followers: 452000,
    signature: "每一个世界，都是我想与你分享的梦。",
  },
  {
    id: "qing-he",
    name: "青禾",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20gentle%20female%20comic%20artist%20with%20long%20hair%20and%20a%20warm%20serene%20smile%2C%20soft%20cream%20and%20green%20tones%2C%20friendly%20anime%20character%20portrait&width=400&height=400&seq=a-qinghe-01&orientation=squarish",
    intro: "治愈系画师，作品温暖明亮，善于捕捉日常中的小确幸。代表作《四季小憩》《糯糯团子》《生命医院》。",
    works: ["四季小憩", "糯糯团子", "生命医院"],
    followers: 518000,
    signature: "想用画笔，把温暖送到你心里。",
  },
  {
    id: "cheng-ye",
    name: "程野",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20confident%20male%20comic%20artist%20with%20short%20dark%20hair%20and%20a%20sharp%20expression%2C%20moody%20teal%20background%2C%20friendly%20anime%20character%20portrait&width=400&height=400&seq=a-chengye-01&orientation=squarish",
    intro: "硬核剧情流作者，涉猎科幻与悬疑，节奏凌厉、反转密集。代表作《星辰猎手》《暗航独驾》《半夏门点》。",
    works: ["星辰猎手", "暗航独驾", "半夏门点"],
    followers: 389000,
    signature: "在宇宙与迷雾之间，寻找真相。",
  },
  {
    id: "su-yan",
    name: "苏言",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20bright%20cheerful%20female%20comic%20artist%20with%20short%20bob%20hair%2C%20fresh%20mint%20studio%20background%2C%20friendly%20anime%20character%20portrait&width=400&height=400&seq=a-suyan-01&orientation=squarish",
    intro: "擅长都市青春与恋爱题材，文风细腻克制，情感描写深入人心。代表作《一封来信》《都市蜜饮》。",
    works: ["一封来信", "都市蜜饮"],
    followers: 421000,
    signature: "把平凡的日子，画成诗。",
  },
  {
    id: "chenshanming",
    name: "陈山明",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20seasoned%20male%20comic%20artist%20with%20grey-streaked%20hair%20and%20a%20warm%20confident%20smile%2C%20deep%20green%20studio%20background%2C%20friendly%20anime%20character%20portrait&width=400&height=400&seq=a-chenshanming-01&orientation=squarish",
    intro: "燃系长篇作者，擅长热血战斗与东方神话题材。代表作《火焰风云》《玄机山海》。",
    works: ["火焰风云", "玄机山海"],
    followers: 635000,
    signature: "燃烧到最后一格分镜。",
  },
];

export const faqs = [
  {
    q: "漫蛙漫画网的「追更提醒」如何生效？",
    a: "你只需在任意作品的详情页点击「追更」并填写接收邮箱完成订阅。当该作品更新最新章节时，系统会第一时间向你的邮箱发送提醒，确保你不会错过任何一话。订阅完全免费，可随时取消。",
  },
  {
    q: "追更订阅会收取费用吗？",
    a: "不会。目前追更提醒订阅服务完全免费，你只需要一个有效的接收邮箱即可。后续推出的会员增值服务将在上线前明确公示说明。",
  },
  {
    q: "作品列表中「连载中 / 已完结 / 不定期更新」有什么区别？",
    a: "连载中表示作品每周或按固定周期稳定更新；已完结表示故事已完整完结，可放心追到最后一话；不定期更新则表示作者因创作节奏等原因更新时间不固定，建议开启追更提醒以便及时获知新章。",
  },
  {
    q: "如何找到我喜欢的作者的全部作品？",
    a: "前往「作者专区」页面，你可以浏览每一位作者的介绍、创作风格以及代表作。点击作者卡片即可查看该作者在漫蛙漫画网收录的全部系列作品，快速建立你的追更清单。",
  },
  {
    q: "最新章节的更新时间是几点？",
    a: "大多数作品会在当天 12:00 与 20:00 两个时段集中发布更新。你可以以作品详情页标注的「最后更新」时间为准，开启追更提醒后无需手动刷新。",
  },
  {
    q: "如果某部作品停更很久，还会继续更新吗？",
    a: "对于「不定期更新」或长期未更新的作品，我们会在作者恢复连载时第一时间同步最新动态，并通过追更提醒通知已订阅的读者。请以作品详情页的状态标注为准。",
  },
];

export const formatViews = (n: number): string => {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
};